import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React from "react";
import { Grid } from "@mui/material";
import SuiBox from "components/SuiBox";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DietChartSettingsNew from "./DietChartSettingsNew";
import DietChartApproval from "./DietChartApproval";
import NewDietPdfLayout from "./NewDietPdfLayout/NewDietPdfLayout";
import DietChartCreationLayoutToggle from "./DietChartCreationLayoutToggle";
import DietChartExpiryToggle from "./ClientDietChartExpiry/ClientDietChartExpiry";
import DietChartTnCToggle from "./DietChartTnCToggle/DietChartTnCToggle";
import AutomatedMessageSettings from "./AutomatedMessageSettings";
import WhatsAppSettings from "./WhatsAppSettings";

const Settings = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox mt={1} mb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} xl={4}>
            <DietChartSettingsNew />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <DietChartApproval />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <NewDietPdfLayout />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <DietChartCreationLayoutToggle />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <DietChartExpiryToggle />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <DietChartTnCToggle />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <AutomatedMessageSettings />
          </Grid>
          {/* <Grid item xs={12} md={12} xl={12}>
            <WhatsAppSettings />
          </Grid> */}
        </Grid>
      </SuiBox>
    </DashboardLayout>
  );
};

export default Settings;
